module.exports = __webpack_public_path__ + "img/left-arrow.03e3633a.svg";